/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { status_action } from "../../App/actions/mapActions";
import { set_value_layer } from "../../App/actions/layerActions";

/*PICTURE*/

/*FUNCTION*/
import getStatusMember from "../../App/validation/get-status-member";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const FlyTo = ({
  feature,
  properties,
  auth,
  project,
  idx,
  indexOfFirstTodo,
  set_value_properties,
  status_action,
  set_value_layer,
}) => {
  const toggle_share = () => {
    set_value_properties({
      key: "feature_will_be_shared_key",
      value: feature.key,
    });
    const { modal_share } = properties;
    set_value_properties({
      key: "modal_share",
      value: !modal_share,
    });
  };

  const on_fly_feature = () => {
    //STEP 1 masukkan ke dalam props feature_key_array untuk styling menonjolkan feature yang di select
    set_value_layer({
      key: "feature_key_selected",
      value: feature.key,
    });

    set_value_layer({
      key: "feature_object_selected",
      value: feature,
    });

    status_action();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props
  const { isAuthenticated } = auth;
  const { user } = auth;
  const { geo_project } = project;

  //content
  let is_author = false;

  if (isAuthenticated) {
    let userCurrentStatus;

    const groups = geo_project?.groups || [];
    if (geo_project._id) {
      userCurrentStatus = getStatusMember(groups, user?._id);
    }
    is_author = !!userCurrentStatus || !!(geo_project?.user?._id === user?._id);
  }

  return (
    <main>
      <div className="h_full text_left">
        {idx + 1 + indexOfFirstTodo}
        <br />
        <button
          className="button margin_bottom background_black"
          style={{
            whiteSpace: "nowrap",
          }}
          onClick={on_fly_feature}
        >
          {dict?.["Fly to"]?.[language]}
        </button>
        {is_author && (
          <>
            <br />
            <button
              className="button background_black"
              onClick={toggle_share}
              feature={feature}
            >
              {dict?.["Share"]?.[language]}
            </button>
          </>
        )}
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_properties,
  status_action,
  set_value_layer,
})(FlyTo);
